export default __webpack_public_path__ + "static/media/membre_hadjer.7e16abd1.JPG";